import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Chat.css";
import { Avatar, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import MicIcon from "@mui/icons-material/Mic";
import db from "./helper";
import firebase from "firebase/compat/app";
import { useStateValue } from "./StateProvider";


function Chat() {
   const [input, setInput] = useState("");
  const [seed, setSeed] = useState("");
  const { roomId } = useParams();
  const [roomName, setRoomName] = useState("");
  const [messages, setMessages] = useState([]);
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    // Update room details and messages whenever roomId changes
    if (roomId) {
      const roomRef = db.collection("rooms").doc(roomId);

      roomRef.get().then((doc) => {
        if (doc.exists) {
          setRoomName(doc.data().name);
        }
      });

      const messagesRef = roomRef.collection("messages").orderBy("timestamp", "asc");
      const unsubscribe = messagesRef.onSnapshot((snapshot) => {
        setMessages(snapshot.docs.map((doc) => doc.data()));
      });

      // Clean up the listener when component unmounts or roomId changes
      return () => {
        unsubscribe();
      };
    }
  }, [roomId]); // Run the effect whenever roomId changes

  useEffect(() => {
    setSeed(Math.floor(Math.random() * 5000));
  }, [roomId]); // Update seed whenever roomId changes

  const sendMessage = (e) => {
    e.preventDefault();
    console.log("You typed >>> ", input);
    console.log("roomsIs",roomId)
    db.collection("rooms").doc(roomId).collection("messages").add({
      message: input,
      name: user.displayName,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setInput("");
  };

  return (
    <div className="chat">
      <div className="chat__header">
        {/* <Avatar src={`https://avatars.dicebear.com/api/human/${seed}.svg`} /> */}

        <div className="chat__headerInfo">
          <h3>{roomName}</h3>
          <p>
            last seen{" "}
            {new Date(
              messages[messages.length - 1]?.timestamp?.toDate()
            ).toUTCString()}
          </p>
        </div>

        <div className="chat__headerRight">
        <IconButton>
             <SearchIcon />
           </IconButton>
           <IconButton>
             <AttachFileIcon />
           </IconButton>
           <IconButton>
             <MoreVertIcon />
           </IconButton>
        </div>
      </div>

      <div className="chat__body">
        {messages.map((message) => (
          <p
            className={`chat__message ${
              message.name === user.displayName && "chat__reciever"
            }`}
          >
            <span className="chat__name">{message.name}</span>
            {message.message}
            <span className="chat__timestamp">
              {new Date(message.timestamp?.toDate()).toUTCString()}
            </span>
          </p>
        ))}
      </div>

      <div className="chat__footer">
        <InsertEmoticonIcon />
        <form>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type a message"
            type="text"
          />
          <button onClick={sendMessage} type="submit">
            Send a message
          </button>
        </form>
        <MicIcon />
      </div>
      <div>Room ID: {roomId}</div>;
    </div>
    
  );
}

export default Chat;

// function Chat() {
//   const [input, setInput] = useState("");
//   const [seed, setSeed] = useState("");
//   const { roomId } = useParams();
//   const [roomName, setRoomName] = useState("");
//   const [messages, setMessages] = useState([]);
//   const [{ user }, dispatch] = useStateValue();

//   useEffect(() => {
//     if (roomId) {
//       db.collection("rooms")
//         .doc(roomId)
//         .onSnapshot((snapshot) => setRoomName(snapshot.data().name));

//       db.collection("rooms")
//         .doc(roomId)
//         .collection("messages")
//         .orderBy("timestamp", "asc")
//         .onSnapshot((snapshot) =>
//           setMessages(snapshot.docs.map((doc) => doc.data()))
//         );
//     }
//   }, [roomId]);

//   useEffect(() => {
//     setSeed(Math.floor(Math.random() * 5000));
//   }, []);

//   const sendMessage = (e) => {
//     e.preventDefault();
//     console.log("you typed ", input);

//     db.collection("rooms").doc(roomId).collection("messages").add({
//       message: input,
//       name: user.displayName,
//       timestamp: firebase.firestore.FieldValue.serverTimestamp(),
//     });

//     setInput("");
//   };

//   return (
//     <div className="chat">
//       <div className="chat__header">
//         <Avatar src={`https://avatars.dicebear.com/api/human/${seed}.svg`} />
//         <div className="chat__headerInfo">
//           <h3>{roomName}</h3>
//           <p>
//             last seen{" "}
//             {new Date(
//               messages[messages.length - 1]?.timestamp?.toDate()
//             ).toUTCString()}
//           </p>
//         </div>
//         <div className="chat__headerRight">
//           <IconButton>
//             <SearchIcon />
//           </IconButton>
//           <IconButton>
//             <AttachFileIcon />
//           </IconButton>
//           <IconButton>
//             <MoreVertIcon />
//           </IconButton>
//         </div>
//       </div>
//       <div className="chat__body">
//         {messages.map((message) => (
//           <p
//             className={`chat__message ${
//               message.name === user.displayName && "chat__reciever"
//             }`}
//           >
//             <span className="chat__name">{message.name} </span>
//             {message.message}
//             <span className="chat__timestamp">
//               {new Date(message.timestamp?.toDate()).toUTCString()}
//             </span>
//           </p>
//         ))}
//       </div>

//       <div className="chat__footer">
//         <InsertEmoticonIcon />
//         <form>
//           <input
//             type="text"
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             placeholder="Type a message"
//           />
//           <button onClick={sendMessage} type="submit">
//             Send a message
//           </button>
//         </form>
//         <MicIcon />
//       </div>
//     </div>
//   );
// }

// export default Chat;
